/**
 * An assistant's answer as safe HTML for the console.
 *
 * The model is asked for plain sentences, but it will still reach for
 * Markdown now and then, and a customer-facing preview must never show
 * literal asterisks. Everything is escaped first; then paragraphs, line
 * breaks, dash or bullet lists, numbered lists, *bold* and _italic_ are
 * rendered. Nothing else is interpreted, so a document cannot inject markup.
 */
export function answerToHtml(text: string): string {
  const escape = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  const inline = (s: string) => escape(s)
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/(^|[\s(])\*([^*\n]+?)\*(?=[\s).,;:!?]|$)/g, '$1<strong>$2</strong>')
    .replace(/(^|[\s(])_([^_\n]+?)_(?=[\s).,;:!?]|$)/g, '$1<em>$2</em>')
    .replace(/`([^`]+)`/g, '$1');
  const blocks = text.replace(/\r\n/g, '\n').trim().split(/\n{2,}/);
  const html: string[] = [];
  for (const block of blocks) {
    const lines = block.split('\n').map((l) => l.trim()).filter(Boolean);
    if (lines.length === 0) continue;
    if (lines.every((l) => /^([-*•]|\d+[.)])\s+/.test(l))) {
      const ordered = /^\d+[.)]\s+/.test(lines[0]);
      const items = lines.map((l) => `<li>${inline(l.replace(/^([-*•]|\d+[.)])\s+/, ''))}</li>`).join('');
      html.push(ordered ? `<ol>${items}</ol>` : `<ul>${items}</ul>`);
      continue;
    }
    const heading = lines.length === 1 && /^#{1,6}\s+/.test(lines[0]);
    if (heading) { html.push(`<p><strong>${inline(lines[0].replace(/^#{1,6}\s+/, ''))}</strong></p>`); continue; }
    html.push(`<p>${lines.map(inline).join('<br>')}</p>`);
  }
  return html.join('');
}
